module.exports = __webpack_public_path__ + "static/media/color-guess.440ebb3e.mp4";